/** Portal locale lookup stays outside the pure formatters used by embedded admin reviews. */
import i18n from '@/i18n';
import { resolveLocale } from './formattersCore';

export {
  resolveLocale,
  formatDate,
  formatRelativeTime,
  formatNumber,
  formatCurrency,
  formatDuration,
} from './formattersCore';

export function activeLocale() {
  return resolveLocale(i18n?.global?.locale?.value);
}
